import { schema } from 'normalizr';

const contactSchema = new schema.Entity('contacts', {});

export default contactSchema;
